import React from 'react';
import { cn } from '@ui/atoms/utils/utils';
import { getOpportunityFields } from '@components/OpportunityListing/utils/helper';
import { isTBillsView } from '@components/OpportunityListing/utils/utils';
import { useRouter } from 'next/router';

const OpportunitySkeleton = () => {
    const router = useRouter();
    const type = router?.query?.type || 'bond';
    const isClosed = router.pathname.includes('closed');
    const isBonds = !isTBillsView(type);
    const fields = getOpportunityFields({
        irr: 'IRR',
        tenure: 'Tenure',
        minInvestment: 'Min Investment',
    });

    return (
        <div className="w-full max-w-[328px] md:max-w-[368px] flex flex-col mx-auto h-[198px]">
            <div
                className={cn(
                    'relative overflow-hidden bg-gray-100 rounded-bl-none rounded-xl h-full',
                    {
                        'rounded-bl-xl': !isBonds,
                        'rounded-bl-none': isBonds,
                    }
                )}
            >
                <div
                    className={cn(
                        `flex items-center justify-center w-24 px-3 py-1 rounded-b-lg h-5 bg-basicWhite absolute top-0 z-10 left-4 animate-pulse`
                    )}
                >
                    <div className="w-24 h-5 shine-effect" />
                </div>

                <div className="flex flex-col justify-center h-full gap-4 pl-4 md:p-4 md:pt-9">
                    <div className="shine-effect"></div>
                    <div className="flex items-start gap-4 flex-col">
                        <div className="flex flex-1 gap-3 items-center pt-0">
                            <div className="w-10 h-10 md:w-[56px] md:h-[56px]">
                                <div className="w-10 h-10 md:w-[56px] md:h-[56px] bg-basicWhite rounded-lg animate-pulse"></div>
                            </div>
                            <div className="flex flex-col gap-2 min-w-full">
                                <div className="h-4 rounded-md bg-basicWhite w-full md:h-6 animate-pulse">
                                    <div className="w-full h-full shine-effect" />
                                </div>
                                <div className="h-4 rounded-md bg-basicWhite w-40 md:h-6 animate-pulse"></div>
                            </div>
                        </div>
                        <div className="flex relative items-center flex-row w-full min-h-0 gap-8 h-10">
                            {fields.map(({ id, label, value, className }) => (
                                <div
                                    className={cn(
                                        'flex flex-col gap-1 flex-none first:justify-end ',
                                        className
                                    )}
                                    key={id}
                                >
                                    <div className="w-16 h-6 md:h-6  rounded-md bg-basicWhite animate-pulse"></div>
                                    <div className="w-6 h-3 rounded-md bg-basicWhite animate-pulse"></div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={cn('flex items-center', {
                    'inline-flex': !isBonds,
                    hidden: isClosed,
                })}
            >
                <div
                    className={cn(
                        'relative w-[204px] md:w-[273px] py-1.5 px-3  rounded-bl-xl flex items-center gap-2 h-7 bg-gray-100'
                    )}
                >
                    <div className="w-full h-full rounded-md bg-basicWhite animate-pulse"></div>
                </div>
                <div className={cn('w-10 h-full place-content-center')}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                    >
                        <path
                            d="M0 0H28L14.5105 20.2342C11.2761 25.0858 5.83095 28 0 28V0Z"
                            fill="#F4F6F8"
                        />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default OpportunitySkeleton;
